<template>
  <v-card-text :is="component" :value="value" />
</template>

<script>
// Components
import SuccessfulReminder from '@/components/opportunities/phase_behaviors/SuccessfulReminder'
import Withdrawal from '@/components/opportunities/phase_behaviors/Withdrawal'
import EmailCommunication from '@/components/opportunities/phase_behaviors/EmailCommunication'
import FinancialAssessment from '@/components/opportunities/phase_behaviors/FinancialAssessment'
import PsychometricAssessment from '@/components/opportunities/phase_behaviors/PsychometricAssessment'
import Questionnaire from '@/components/opportunities/phase_behaviors/Questionnaire'
import SecondaryTranscript from '@/components/opportunities/phase_behaviors/SecondaryTranscript'

// Vue Component
export default {
  components: {
    Withdrawal,
    SuccessfulReminder,
    EmailCommunication,
    FinancialAssessment,
    PsychometricAssessment,
    Questionnaire,
    SecondaryTranscript,
  },
  props: {
    value: { type: Object, required: true }
  },
  computed: {
    component() {
      return this.value.type.split('::')[1]
    }
  }
}
</script>
